import { render, staticRenderFns } from "./SelectPeopleList.vue?vue&type=template&id=2a1c6b78&scoped=true"
import script from "./SelectPeopleList.vue?vue&type=script&lang=js"
export * from "./SelectPeopleList.vue?vue&type=script&lang=js"
import style0 from "./SelectPeopleList.vue?vue&type=style&index=0&id=2a1c6b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1c6b78",
  null
  
)

export default component.exports